import { Injectable } from '@angular/core';
import { DateTimeAdapter, OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';
import { TranslateService } from '@ngx-translate/core';
import { IaithService } from '../iaith/iaith.service';
import { IaithStorfaService } from '../iaith/iaith-storfa.service';

@Injectable({
  providedIn: 'root'
})
export class OwlDateTimeIaithServiceService extends OwlDateTimeIntl {

  constructor(
    private translateService: TranslateService,
    private iaithService: IaithService,
    private iaithStorfaService: IaithStorfaService,
    private dateTimeAdapter: DateTimeAdapter<any>) {

    super();
    this.nolIaith();

    this.translateService.onLangChange.subscribe(() => {
      this.nolIaith();
    });
  }

  nolIaith(): void {
    let iaith = this.iaithStorfaService.nol('iaith');

    this.dateTimeAdapter.setLocale(iaith);

    this.cancelBtnLabel = this.iaithService.nolTestun('ui.canslo');
    this.setBtnLabel = this.iaithService.nolTestun('ui.setio');
    this.rangeFromLabel = this.iaithService.nolTestun('ui.dyddiado');
    this.rangeToLabel = this.iaithService.nolTestun('ui.dyddiadi');
    this.hour12AMLabel = this.iaithService.nolTestun('ui.yb');
    this.hour12PMLabel = this.iaithService.nolTestun('ui.yp');
  }
}